import { createApp } from 'vue';
import state from '@/state';
import createEl from '@/utils/createEl';
import StickyToast from '@/components/StickyToast';

export const STICKY_DELAY_MS = 500;

export const initialHistory = window.history.length;

export const toastStatus = sessionStorage.getItem('gmf_closed_sticky_toast');

export const TOAST_STATUS = {
    LOADED: 1,
    CLOSED: 2,
}

let stickyToastWrapper;
if (state.merchantConfig.widgets.stickyToast?.enabled) {
    stickyToastWrapper = createEl('div', 'gmf-sticky-toast-wrapper', document.body);
    // set data-gmf attribute to avoid interpreting content as widgets
    stickyToastWrapper.setAttribute('data-gmf', '');
}

let stickyToastOpen = false;
export const createStickyToast = (toast) => {
    if (! toast) {
        if (process.env.NODE_ENV === 'development') {
            console.error('Could not create sticky toast, missing toast variable');
        }
        return;
    }

    // User has closed toast and it should not be opened again
    if (sessionStorage.getItem('gmf_closed_sticky_toast') === TOAST_STATUS.CLOSED) {
        return;
    }

    // If user has not seen toast mark it as "Fist load" and don't show it this page load.
    if (! sessionStorage.getItem('gmf_closed_sticky_toast')) {
        sessionStorage.setItem('gmf_closed_sticky_toast', TOAST_STATUS.LOADED);
        return;
    }

    if (stickyToastOpen) return;
    stickyToastOpen = true;

    const stickyToast = createApp(StickyToast, {
        toast,
        close: () => {
            stickyToast.unmount();
            sessionStorage.setItem('gmf_closed_sticky_toast', TOAST_STATUS.CLOSED);
        },
    });
    const stickyToastContainer = createEl('div', 'gmf-sticky-toast-container', stickyToastWrapper);
    stickyToast.mount(stickyToastContainer);
}

export const onNavigation = (callback) => {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    // User has closed toast not nessesary to check for further navigations
    if (sessionStorage.getItem('gmf_closed_sticky_toast') === TOAST_STATUS.CLOSED) {
        window.removeEventListener('popstate', callback);
        history.pushState = originalPushState;
        history.replaceState = originalReplaceState;
        return;
    }

    history.pushState = function (...args) {
        originalPushState.apply(this, args);
        callback();
    };
    history.replaceState = function (...args) {
        originalReplaceState.apply(this, args);
        callback();
    };
    window.addEventListener('popstate', callback);
    
    callback();
};